import * as React from 'react'

function SvgPencil(props, svgRef) {
  return (
    <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        clipRule="evenodd"
        d="M0 15.25V19h3.75L14.81 7.94l-3.75-3.75L0 15.25zM17.71 5.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgPencil)
export default ForwardRef
